import { render, staticRenderFns } from "./RecruiterJoiningData.vue?vue&type=template&id=bc6f5da2&scoped=true&"
import script from "./RecruiterJoiningData.vue?vue&type=script&lang=js&"
export * from "./RecruiterJoiningData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6f5da2",
  null
  
)

export default component.exports